namespace AgerLMS.Logging {
    export interface QuizAnswerEnsureRequest extends Serenity.ServiceRequest {
        UserId?: number;
        QuestionId?: number;
        UserAnswer?: number;
        Attempt?: number;
    }
}
